import { useEffect } from 'react';

import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import { onlyNumber } from 'utils/formatter';

import Grid from '@material-ui/core/Grid';

import { Textfield, TextLabel } from 'components/common';

import { CREDIT_CARD_MAX_LENGTH, EXPIRY_MAX_LENGTH, PIN_MAX_LENGTH } from 'settings/constants/common';

const CreditCardForm = ({ creditCardNumber, pin, expiryMonth, expiryYear, handleChange }) => {
  const { formatMessage } = useIntl();

  const resetFormState = () => ['creditCardNumber', 'pin', 'expiryMonth', 'expiryYear'].map(state => handleChange(state, ''));

  // when component unmount remove state to avoid autofilled form when user open selfUnlock again
  useEffect(() => () => resetFormState(), []);

  return (
    <>
      <Grid container spacing={1} alignItems="center" className="form-spacing">
        <Grid item xs={12} sm={5}>
          <TextLabel
            hasIcon
            isAssetIcon
            className="ml2"
            label={formatMessage({ id: 'selfUnlock.modal.container.cc.ccNumber' })}
            tooltipTitle={formatMessage({ id: 'selfUnlock.modal.container.cc.ccNumberTooltip' })}
          />
        </Grid>
        <Grid item xs={12} sm={7}>
          <Textfield
            id="creditCardNumber"
            value={creditCardNumber}
            autoComplete="cc-number"
            maxLength={CREDIT_CARD_MAX_LENGTH}
            onChange={e => handleChange('creditCardNumber', onlyNumber(e.target.value))}
            placeholder={formatMessage({ id: 'selfUnlock.modal.container.cc.ccNumberPlaceholder' })}
          />
        </Grid>
      </Grid>

      <Grid container spacing={1} alignItems="center" className="form-spacing">
        <Grid item xs={12} sm={5}>
          <TextLabel
            hasIcon
            isAssetIcon
            className="ml2"
            label={formatMessage({ id: 'selfUnlock.modal.container.cc.pin' })}
            tooltipTitle={formatMessage({ id: 'selfUnlock.modal.container.cc.pinTooltip' })}
          />
        </Grid>
        <Grid item xs={12} sm={7}>
          <Textfield
            id="pin"
            value={pin}
            type="password"
            maxLength={PIN_MAX_LENGTH}
            onChange={e => handleChange('pin', onlyNumber(e.target.value))}
            placeholder={formatMessage({ id: 'selfUnlock.modal.container.cc.pinPlaceholder' })}
          />
        </Grid>
      </Grid>

      <Grid container spacing={1} alignItems="center">
        <Grid item xs={12} sm={5}>
          <TextLabel className="ml2" label={formatMessage({ id: 'selfUnlock.modal.container.cc.ccExpiry' })} />
        </Grid>
        <Grid container spacing={1} item xs={12} sm={7}>
          <Grid item xs={12} sm={3}>
            <Textfield
              id="MM"
              value={expiryMonth}
              autoComplete="cc-exp-month"
              maxLength={EXPIRY_MAX_LENGTH}
              placeholder={formatMessage({ id: 'selfUnlock.modal.container.cc.mm' })}
              onChange={e => handleChange('expiryMonth', onlyNumber(e.target.value))}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <Textfield
              id="YY"
              value={expiryYear}
              autoComplete="cc-exp-year"
              maxLength={EXPIRY_MAX_LENGTH}
              onChange={e => handleChange('expiryYear', onlyNumber(e.target.value))}
              placeholder={formatMessage({ id: 'selfUnlock.modal.container.cc.yy' })}
            />
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

CreditCardForm.defaultProps = {
  pin: '',
  expiryYear: '',
  expiryMonth: '',
  creditCardNumber: '',
};

CreditCardForm.propTypes = {
  pin: PropTypes.string,
  expiryYear: PropTypes.string,
  expiryMonth: PropTypes.string,
  creditCardNumber: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
};

export default CreditCardForm;
